import axios from '@axios'

// Раздел «Обратная связь»: письмо в свободной форме.
// Раньше на его месте лежал модуль notify с пустыми заглушками — форма
// вызывала действие, которое ничего не делало, и текст пропадал.
export default {
  namespaced: true,
  state: {
    sending: false,
    prefill: { name: '', email: '' },
  },
  getters: {
    isSending: state => state.sending,
    getPrefill: state => state.prefill,
  },
  mutations: {
    set_sending(state, value) {
      state.sending = value
    },
    set_prefill(state, value) {
      state.prefill = value
    },
  },
  actions: {
    // Имя и почту подставляем из аккаунта: человек и так вошёл, заставлять
    // его печатать свои же данные незачем. Поправить в форме можно.
    fetchPrefill({ commit }) {
      return axios({ method: 'get', url: '/api/v1/support' })
        .then(response => {
          const data = (response && response.data) || {}
          commit('set_prefill', { name: data.name || '', email: data.email || '' })

          return data
        })
        .catch(() => ({}))
    },

    // true — сервер обращение ПРИНЯЛ. Общий перехватчик ошибок в @axios не
    // бросает исключение, а возвращает объект ошибки, поэтому смотрим именно
    // на поле success в теле ответа.
    submit({ commit }, { name, email, text }) {
      commit('set_sending', true)

      return axios({
        method: 'post',
        url: '/api/v1/support/submit',
        data: { name, email, text },
      })
        .then(response => {
          commit('set_sending', false)

          return !!(response && response.data && response.data.success)
        })
        .catch(() => {
          commit('set_sending', false)

          return false
        })
    },
  },
}
